import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { InvoiceStatus } from "~/modules/billing/api/invoiceStatus/invoiceStatusIdTypes.ts";

export function indexInvoiceStatus(): AxiosApiResponsePromise<InvoiceStatus[]> {
	return axiosApi.get("invoice-statuses");
}

